export default __webpack_public_path__ + "static/media/banner-2.6b7dcf20.png";